
import Vue from "vue";
import { getnerateString } from "@/lib";

export default Vue.extend({
  props: {
    rate: Number,
    index: Number,
  },
  methods: {
    onChangeRate() {
      this.$emit("change-rate", this.index + 1);
    },
  },
  computed: {
    startId() {
      return `star-${Date.now()}-${getnerateString()}`;
    },
    persent(): number {
      const persent = this.rate * 100;
      return isNaN(persent) ? 0 : persent;
    },
  },
});
